/**
 * Validates if the provided URL is valid
 * @param url - The URL string to validate
 * @returns true if the URL is valid, false otherwise
 */
export const validateUrl = (url: string): boolean => {
  try {
    // eslint-disable-next-line no-new
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

/**
 * Normalize the URL adding https:// if it's not present
 * @param url - The URL string to normalize
 * @returns The normalized URL with protocol
 */
export const addHTTPSProtocolToUrl = (url: string): string => {
  if (!url) return '';

  // If the URL doesn't have a protocol, add https://
  if (!/^https?:\/\//i.test(url)) {
    return `https://${url}`;
  }
  return url;
};
